export default function(video) {
    const { public: { bunnyCDN }} = useRuntimeConfig();

    const seoTitle = computed(() => {
        return `MedPeers | ${ toValue(video)?.title }`;
    });

    const seoDescription = computed(() => {
        if (!toValue(video)?.description) {
            return 'Watch this video on MedPeers. The educational platform for healthcare professionals';
        }

        return toValue(video)?.description;
    });

    const seoImage = computed(() => {
        if (toValue(video)?.bunny_id) {
            return `${bunnyCDN}/${toValue(video)?.bunny_id}/${toValue(video)?.bunny_thumbnail}`;
        }

        return asset('/images/og/default.png');
    });

    useSeoMeta({
        title: seoTitle,
        description: seoDescription,
        ogDescription: seoDescription,
        ogImage: seoImage,
        ogType: 'video.other',
    });

    const jsonLd = computed(() => {
        return {
            '@context': 'https://schema.org',
            '@type': 'VideoObject',
            'name': seoTitle.value,
            'description': seoDescription.value,
            'thumbnailUrl': [seoImage.value],
            'uploadDate': toValue(video).published_at,
            'duration': toValue(video).duration,
            'requiresSubscription': true,
            interactionStatistic: {
                '@type': 'InteractionCounter',
                'interactionType': { '@type': 'WatchAction' },
                'userInteractionCount': toValue(video).views,
            }
        };
    });

    useHead({
        script: [
            {
                type: 'application/ld+json',
                children: JSON.stringify(jsonLd.value),
            },
        ],
    });
}
